// Core React and hooks
import React, { Fragment, lazy, Suspense } from "react";
import { useEffect, useState } from "react";
// Component styles and icons
import "./Dashboard.css";
import LoadingIcon from "../../assets/icons/LoadingIcon";
import LeftNavigation from "../../components/LeftNavigation/LeftNavigation";
// Services
import { fetchSectionsList } from "../../service/VariableService";
import { useVisualization } from "../../contexts/visualization/VisualizationContext";
// Lazy loaded component for performance optimization
const MainContent = lazy(() => import('../../components/MainContent/MainContent'));

const renderLoader = () => <LoadingIcon width={50} height={50} />;

function Dashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const { sectionList, setSectionList, selectedSection, setSelectedSection } = useVisualization();

  useEffect(() => {
    fetchAndStoreSectionList();
    // eslint-disable-next-line
  }, []);

  // URL sync effect (no changes needed here if selection is fixed)
  useEffect(() => {
    if (selectedSection?.id) {
      window.history.replaceState(null, "", `?sf=${selectedSection.id}`);
    }
  }, [selectedSection]);

  const fetchAndStoreSectionList = async () => {
    setIsLoading(true);
    try {
      const resp = await fetchSectionsList();
      if (!resp) return;

      setIsLoading(false);
      
      // Get first variable in first subsection of default section
      const firstSection = resp.defaultSelectedSection;
      const firstSubsection = Object.keys(resp.sectionList[firstSection])[0];
      const firstVariable = resp.sectionList[firstSection][firstSubsection][0];

      let currSelectedSection = firstVariable;

      // Handle URL parameter
      const urlVarId = new URLSearchParams(window.location.search).get("sf");
      if (urlVarId) {
        Object.values(resp.sectionList).forEach((section) => {
          Object.values(section).forEach((subsection) => {
            subsection.forEach((variable) => {
              if (variable.id === parseInt(urlVarId)) {
                currSelectedSection = variable;
              }
            });
          });
        });
      }

      setSectionList(resp.sectionList);
      setSelectedSection(currSelectedSection);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContent">
      {isLoading ? (
        <LoadingIcon width={50} height={50} />
      ) : (
        <Suspense fallback={renderLoader()}>
          {sectionList && selectedSection && (
            <>
              <LeftNavigation
                sectionList={sectionList}
                selectedSection={selectedSection}
                handleSelectSections={setSelectedSection}
              />
              <MainContent />
            </>
          )}
        </Suspense>
      )}
    </div>
  );
}


export default Dashboard;